export function consultaFiltroDepartamento(idsSelecionados: string[], totalDepartamentos: number) {
  const ids = [...new Set((idsSelecionados || []).filter(id => !!id))];
  if (!ids.length || (totalDepartamentos > 0 && ids.length >= totalDepartamentos)) {
    return undefined;
  }
  return ids;
}

export function funcionariosNoRecorteDepartamento<T extends { departamentoId?: string }>(
  funcionarios: T[],
  idsSelecionados: string[],
  totalDepartamentos: number
) {
  const recorte = consultaFiltroDepartamento(idsSelecionados, totalDepartamentos);
  if (!recorte) {
    return funcionarios;
  }
  return funcionarios.filter(funcionario => !!funcionario.departamentoId && recorte.includes(funcionario.departamentoId));
}
